import { type MutableRefObject, useEffect } from 'react'
import type { ShapeManagerRef } from '@/lib/shapes/types/shape-manager-ref'

/**
 * Clears the canvas selection on entering crop mode. A hook of its own rather than part of
 * `use-crop-session` only because its effect runs after Text on a Path's (`use-text-on-path-session`).
 */
export function useCropSelectionClear({
  isCropMode,
  internalShapeManagerRef,
}: {
  isCropMode: boolean
  internalShapeManagerRef: MutableRefObject<ShapeManagerRef | null>
}) {
  // Crop mode: clear selection so the normal selection chrome never overlaps the crop frame.
  useEffect(() => {
    if (!isCropMode) return
    internalShapeManagerRef.current?.clearSelection()
  }, [isCropMode, internalShapeManagerRef])
}
